export default __webpack_public_path__ + "static/media/IconPhone.a978e893.svg";